import React from "react";
import Link from "next/link";
import HomeHero from "./home-hero";

const COPY = {
	en: {
		title: "U.S. Industrial Components. Direct Access to Manufacturers.",
		lead: "We connect industrial distributors, machinery manufacturers, and maintenance companies in Latin America with U.S. manufacturers of hydraulic, pneumatic, electrical, and mechanical components.",
		detailEmphasis:
			"Access to inventory available in the United States can help you find solutions without waiting for them to be manufactured to order.",
		products: "Explore Products",
		productsHref: "/en/products",
		quote: "Request a Quote",
		quoteHref: "/en/contact-us",
	},
	es: {
		title: "Componentes Industriales de EE. UU. Acceso a Fabricantes",
		lead: "Conectamos distribuidores industriales, fabricantes de maquinaria y empresas de mantenimiento en Latinoamérica con fabricantes estadounidenses de componentes hidráulicos, neumáticos, eléctricos y mecánicos.",
		detailEmphasis:
			"El acceso a inventario disponible en Estados Unidos puede ayudarle a encontrar soluciones sin esperar a que se fabriquen bajo pedido.",
		products: "Explorar productos",
		productsHref: "/es/productos",
		quote: "Solicitar una cotización",
		quoteHref: "/es/contactenos",
	},
};

export default function HomeEn({ locale = "en", carouselSections = [] }) {
	const copy = COPY[locale] || COPY.en;

	return (
		<section className="tu-en-home" aria-labelledby="tu-en-home-title">
			<div className="tu-container tu-en-home__stage">
				<div className="tu-en-home__copy">
					<h1 id="tu-en-home-title" className="tu-en-home__title">
						{copy.title}
					</h1>
					<p className="tu-en-home__lead">{copy.lead}</p>
					{copy.detailEmphasis ? (
						<p className="tu-en-home__lead tu-en-home__note">
							<strong>{copy.detailEmphasis}</strong>
						</p>
					) : null}
					<div className="tu-en-home__actions">
						<Link href={copy.productsHref} className="tu-btn tu-btn-primary">
							{copy.products}
						</Link>
						<Link href={copy.quoteHref} className="tu-btn tu-btn-outline">
							{copy.quote}
						</Link>
					</div>
				</div>
				<div className="tu-en-home__media">
					<HomeHero locale={locale} sections={carouselSections} />
				</div>
			</div>
		</section>
	);
}
